import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import Button from "./Button";

const isIOS = () => {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
};

const MadeInAmerica = () => {
  const location = useLocation();
  const isIndustrial = location.pathname.includes('/industrial');
  const aboutPath = isIndustrial ? '/industrial/about' : '/household/about';
  const [isIOSDevice, setIsIOSDevice] = useState(false);

  useEffect(() => {
    setIsIOSDevice(isIOS());
  }, []);

  return (
    <section className="bg-white py-12 md:py-20">
      <div className="mx-auto px-4 max-w-[1600px]">
        <motion.div
          className="bg-gradient-to-br from-[#D3242A] to-[#9B1218] rounded-2xl md:rounded-3xl p-6 md:p-16 shadow-2xl overflow-hidden"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-8">
            <motion.div
              className="w-full md:w-1/2 flex justify-center items-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="relative">
                {isIOSDevice ? (
                  <img
                    src="https://images.ctfassets.net/hdznx4p7ef81/vgdFbFIQRGKdDk5Sjmj0A/4c72a02b6a85912292e645097b27055c/Gen-4_Flag-image.png"
                    alt="American Flag"
                    className="w-48 h-auto md:w-96 lg:w-[500px] object-contain scale-125 md:scale-1175 lg:scale-200 -rotate-[0deg]"
                  />
                ) : (
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-48 h-auto md:w-96 lg:w-[500px] object-contain scale-125 md:scale-1175 lg:scale-200 -rotate-[0deg]"
                  >
                    <source
                      src="https://videos.ctfassets.net/hdznx4p7ef81/7FAYaB8msFZnVuKOMhuFse/30b2c632640ff0043ceea78211521787/Gen-4_Flag8.webm?fm=webm&q=80"
                      type="video/webm"
                    />
                    <source
                      src="https://videos.ctfassets.net/hdznx4p7ef81/7FAYaB8msFZnVuKOMhuFse/30b2c632640ff0043ceea78211521787/Gen-4_Flag8.mp4?fm=mp4&q=80&fl=progressive"
                      type="video/mp4"
                    />
                  </video>
                )}
              </div>
            </motion.div>
            <div className="w-full md:w-1/2 relative z-10 text-center flex flex-col items-center justify-center">
              <motion.h2
                className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6 text-center"
                style={{ fontFamily: "Geogrotesque, sans-serif" }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
              >
                PROUDLY MADE IN AMERICA*
              </motion.h2>
              <motion.p
                className="text-lg md:text-xl text-white/90 mb-6 md:mb-8 text-center max-w-2xl"
                style={{ fontFamily: "Geogrotesque, sans-serif" }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                viewport={{ once: true }}
              >
                Our commitment to American manufacturing* means you get the highest quality products, 
                supporting local jobs and communities while reducing environmental impact.
              </motion.p>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
                viewport={{ once: true }}
                className="flex justify-center"
              >
                <Link to={aboutPath}>
                  <Button
                    variant="secondary"
                    size="large"
                  >
                    Learn More About Us
                  </Button>
                </Link>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MadeInAmerica;